
export const apiConstants = {
  url: "/api/blacklist"
};
